/*
 * @Author: 小周
 * @Date: 2023-10-18 14:47:08
 * @LastEditTime: 2024-08-02 16:31:12
 * @LastEditors: MrZHLF
 * @Description: App内登陆
 */

import { isCheckApp, checkDevice } from '@/utils/index'
import { getTokenInAppAndRedirect } from '@/utils/appMethods'
import { setToken } from '@/utils/tokenStore'
import { setUser } from '@/utils/userStore'

export function _postMessage(val, name) {
  if (val) {
    val.callback = 'nativeCommonCallback'
  } else {
    val = {
      callback: 'nativeCommonCallback',
    }
  }
  var channel = new MessageChannel()
  window.nativeCommonCallback = function (nativeValue) {
    channel.port1.postMessage(nativeValue)
  }
  window.webkit && window.webkit.messageHandlers[name].postMessage(val)
  window.Android && window.Android.tongYong(name, JSON.stringify(val))
  return new Promise((resolve) => {
    channel.port2.onmessage = function (e) {
      var data = e.data
      resolve(data)
      channel = null
      window.nativeCommonCallback = null
    }
  })
}

export async function appLogin() {
  let isApp = false
  let isStatus = false
  let isDxApp = await isCheckApp()

  if (isDxApp) {
    // app环境
    isApp = true
    const token = await getTokenInAppAndRedirect()
    setToken(token)
    if (token) {
      let resp = await _postMessage(null, 'userInfo')
      const data = JSON.parse(resp)
      let userInfo = (data && data.user && data.user.result) || data
      if (userInfo && userInfo.userId) {
        setUser(userInfo)
      }
      isStatus = true
    } else {
      isStatus = false
    }
  } else {
    isApp = false
    isStatus = false
  }

  return {
    isApp,
    isStatus,
  }
}

export function app_postMessage(name, val) {
  let platform = checkDevice()
  let callback = ''
  if (val?.callback) {
    callback = val.callback
  } else {
    callback = 'nativeCommonCallback'
  }
  val.callback = callback
  var channel = new MessageChannel()
  window[callback] = function (nativeValue) {
    channel.port1.postMessage(nativeValue)
  }
  if (platform == 'IOS') {
    window.webkit && window.webkit.messageHandlers[name].postMessage(val)
  } else if (platform == 'Android') {
    window.Android && window.Android.tongYong(name, JSON.stringify(val))
  }
  return new Promise((resolve) => {
    channel.port2.onmessage = function (e) {
      var data = e.data
      resolve(data)
      channel = null
      window[callback] = null
    }
  })
}

/**
 * @param {object} userInfo app返回用户信息
 * @description 获取App不登录用户信息
 */
export async function getAppDoNotLoginUserInfo() {
  let platform = checkDevice()
  let isDxApp = await isCheckApp()
  if (isDxApp) {
    let info = null
    if (platform == 'IOS') {
      //此处因安卓ios获取用户id不触发登录行为api不一致而判断处理
      info = await app_postMessage('getInfo', { needLogin: '0' })
    } else if (platform == 'Android') {
      info = await app_postMessage('getUserInfo', { needLogin: '0' })
    }
    let data = JSON.parse(info)
    let userInfo = (data && data.user && data.user.result) || data
    console.log('🚀 ~ getAppDoNotLoginUserInfo ~ userInfo:', userInfo)
    if (data.token) {
      setToken(data.token)
      setUser(userInfo)
    }
    return userInfo
  }
}
